import { render, staticRenderFns } from "./LightboxHeadline.vue?vue&type=template&id=095bef76&scoped=true&"
import script from "./LightboxHeadline.vue?vue&type=script&lang=js&"
export * from "./LightboxHeadline.vue?vue&type=script&lang=js&"
import style0 from "./LightboxHeadline.vue?vue&type=style&index=0&id=095bef76&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095bef76",
  null
  
)

export default component.exports